const OPENER = "[data-dice-stage=roller] [data-dice-roller-target=opener]";

// Opens the page's floating dice roller; its opener toggles, so an open roller is left alone.
export function openRoller() {
	const opener = document.querySelector<HTMLElement>(OPENER);
	if (opener && opener.getAttribute("aria-expanded") !== "true") opener.click();
}
